import Mousetrap from 'mousetrap';
import UIUtils from './ui-utils.js';
import { EditFormHandler } from './edit-form-handler.js';

export default class ArtworkHandlers {
    constructor(artworkId) {
        this.artworkId = artworkId;
        this.initEventListeners();
    }

    initEventListeners() {

        //const contentButton = document.querySelector('.btn-action.edit-content');
        //const pricingButton = document.querySelector('.btn-action.edit-pricing');
        const deleteButton = document.querySelector('.btn-action.delete');
        const contentTags = document.querySelectorAll('.content-tag');
        const finalScoreLinkButton = document.querySelector('.final-score');
        const categoriesButton = document.querySelector('.btn-action.categories');
        const pricingButton = document.querySelector('.btn-action.pricing');
        const setMyRatingButton = document.querySelector('.btn-my-rating');

        if (deleteButton) {
            deleteButton.addEventListener('click', () => this.handleDelete());
        }

        if (finalScoreLinkButton) {
            finalScoreLinkButton.addEventListener('click', () => this.handleFinalScoreView());
        }

        if (categoriesButton) {
            categoriesButton.addEventListener('click', () => this.handleCategoriesView());
        }

        if (pricingButton) {
            pricingButton.addEventListener('click', () => this.handlePricingView());
        }

        if (setMyRatingButton) {
            setMyRatingButton.addEventListener('click', () => this.handleMyRatingView());
        }

        contentTags.forEach(tag => {
            tag.addEventListener('click', (event) => this.toggleTag(event));
        });

        Mousetrap.bind('del', () => this.handleDelete());
    }

    handleDelete() {
        //const url = ;
        //this.openModal(url);

        const modal = UIUtils.openModal(`/modal/delete-artwork/${this.artworkId}`, {}, () => {

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');

            if (formElement) {

                const endpoint = '/delete-artwork-confirmed';
                new EditFormHandler(formElement, endpoint, this.artworkId);

                document.addEventListener('formSaved', (e) => {

                    if (e.detail && e.detail.success) {

                        modal.close();
                        console.log('Deleted artwork successfully');

                        UIUtils.toast('success', 'Artwork deleted.', () => {
                            window.location.reload();
                        });
                    }
                }, { once: true });
            }
        },
            () => { },
            () => { return true; });

    }

    handleFinalScoreView() {

        const url = `/modal/ratings-summary/${this.artworkId}`;

        const modal = UIUtils.openModal(url, {}, () => {

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');
            if (formElement) {

                new EditFormHandler(formElement, url, this.artworkId);

                document.addEventListener('formSaved', (e) => {

                    if (e.detail && e.detail.success) {

                        modal.close();
                        console.log('Ratings updated successfully');

                        UIUtils.toast('success', 'Ratings updated.', () => {
                            window.location.reload();
                        });
                    }
                }, { once: true });
            }
        },
            () => { },
            () => { return true; });
    }

    handleCategoriesView() {
        const modal = UIUtils.openModal(`/modal/artwork-categories/${this.artworkId}`, {}, () => {
            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');
            if (formElement) {
                const endpoint = '/set-artwork-categories';
                new EditFormHandler(formElement, endpoint, this.artworkId);

                document.addEventListener('formSaved', (e) => {
                    if (e.detail && e.detail.success) {
                        modal.close();
                        console.log('Applied artwork categories successfully');
                        UIUtils.toast('success', 'Categories updated.', () => {
                            window.location.reload();
                        });
                    }
                }, { once: true });
            }

            //function filterCategories() {

            //    const input = modal.modal.querySelector("#categoryFilter");

            //    if (!input) return;

            //    const filter = input.value.toUpperCase();
            //    const cardContainer = modal.modal.querySelector("#categoryContainer");
            //    const cards = cardContainer.getElementsByTagName("li");

            //    for (let i = 0; i < cards.length; i++) {
            //        const label = cards[i].querySelector("label, span");
            //        if (label) {
            //            const txtValue = label.textContent || label.innerText;
            //            const display = txtValue.toUpperCase().indexOf(filter) > -1 ? "" : "none";
            //            cards[i].style.display = display;

            //            if (display === "") {
            //                let parent = cards[i].closest('ul');
            //                while (parent && parent.id !== "categoryContainer") {
            //                    parent.style.display = "";
            //                    parent = parent.closest('ul');
            //                }
            //            }
            //        }
            //    }
            //}

            function toggleSubcategories(elementId) {
                const subCategoryList = modal.modal.querySelector(`#${elementId}`);
                if (subCategoryList) {
                    const display = subCategoryList.style.display === "none" ? "block" : "none";
                    subCategoryList.style.display = display;
                }
            }

            function toggleValueTag(element) {
                element.classList.toggle('on');
            }

            // Attach event listeners
            var categoryFilter = modal.modal.querySelector("#categoryFilter");

            //if (categoryFilter) {
            //    modal.modal.querySelector("#categoryFilter").onkeyup = filterCategories;
            //}

            modal.modal.querySelectorAll('[data-toggle]').forEach(toggle => {
                toggle.onclick = function () {
                    toggleSubcategories(toggle.getAttribute('data-toggle'));
                };
            });

            modal.modal.querySelectorAll('.value-tag').forEach(tag => {
                tag.onclick = function () {
                    toggleValueTag(tag);
                };
            });

            // Register the clear categories button handler here
            const clearCategoriesButton = modal.modal.querySelector('.btn-clear-categories');
            if (clearCategoriesButton) {
                clearCategoriesButton.addEventListener('click', () => this.handleClearCategories(modal, this.artworkId));
            }

        }, () => { }, () => { return true; });
    }

    handleClearCategories(modal, artworkId) {
        fetch(`/clear-artwork-categories/${artworkId}`, { method: 'POST' })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Network response was not ok, status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (data.success) {
                    console.log('Categories cleared successfully');

                    window.location.reload();

                    //this.reloadBrowseList();

                    UIUtils.toast('success', 'Cleared categories.', () => {
                        //window.location.reload();
                    });

                } else {
                    console.error('Failed to clear categories');
                }
            })
            .catch(error => {
                console.error('Error clearing categories:', error);
            });
    }

    handlePricingView() {
        const modal = UIUtils.openModal(`/modal/artwork-pricing/${this.artworkId}`, {}, () => {

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');
            if (formElement) {
                const endpoint = '/set-artwork-pricing';
                new EditFormHandler(formElement, endpoint, this.artworkId);

                document.addEventListener('formSaved', (e) => {
                    if (e.detail && e.detail.success) {
                        modal.close();
                        console.log('Applied artwork pricing successfully');
                        UIUtils.toast('success', 'Pricing updated.', () => {
                            window.location.reload();
                        });
                    }
                }, { once: true });
            }

            // Register the clear categories button handler here
            const clearCategoriesButton = modal.modal.querySelector('.btn-clear-pricing');
            if (clearCategoriesButton) {
                clearCategoriesButton.addEventListener('click', () => this.handleClearPricing(modal, this.artworkId));
            }

        }, () => { }, () => { return true; });
    }

    handleClearPricing(modal, artworkId) {
        fetch(`/clear-artwork-pricing/${artworkId}`, { method: 'POST' })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Network response was not ok, status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (data.success) {
                    console.log('Pricing cleared successfully');

                    window.location.reload();

                    //this.reloadBrowseList();

                    UIUtils.toast('success', 'Cleared pricing.', () => {
                        //window.location.reload();
                    });

                } else {
                    console.error('Failed to clear pricing');
                }
            })
            .catch(error => {
                console.error('Error clearing pricing:', error);
            });
    }

    handleMyRatingView() {
        const modal = UIUtils.openModal(`/modal/artwork-rating/${this.artworkId}`, {}, () => {

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');
            if (formElement) {
                const endpoint = '/set-artwork-rating';
                new EditFormHandler(formElement, endpoint, this.artworkId);

                document.addEventListener('formSaved', (e) => {
                    if (e.detail && e.detail.success) {
                        modal.close();
                        console.log('Applied artwork rating successfully');
                        console.dir(e.detail);

                        //update my rating display
                        updateMyRatingDisplay(e.detail.data.rating);

                        UIUtils.toast('success', 'Rating updated.', () => {
                            window.location.reload();
                        });

                    }
                }, { once: true });
            }

            function updateMyRatingDisplay(rating) {
                const myRatingDiv = document.querySelector('.my-rating');
                let ratingHtml = '';

                switch (rating) {
                    case 0:
                        ratingHtml = '<a href="/rated/reject" class="dark:text-red-500 dark:hover:text-red-600">Reject</a>';
                        break;
                    case 2:
                        ratingHtml = '<a href="/rated/fair" class="dark:text-yellow-500 dark:hover:text-yellow-600">Fair</a>';
                        break;
                    case 4:
                        ratingHtml = '<a href="/rated/good" class="dark:text-blue-500 dark:hover:text-blue-600">Good</a>';
                        break;
                    case 8:
                        ratingHtml = '<a href="/rated/best" class="dark:text-green-500 dark:hover:text-green-600">Best</a>';
                        break;
                    default:
                        ratingHtml = '<span class="dark:text-neutral-400">Not rated</span>';
                        break;
                }

                myRatingDiv.innerHTML = ratingHtml;
            }

            // Toggle 'on' class on clicked '.btn-set-rate' button and update hidden input
            const ratingButtons = modal.modal.querySelectorAll('.btn-set-rating');
            const ratingInput = modal.modal.querySelector('#Rating');

            if (ratingButtons) {
                ratingButtons.forEach(button => {
                    button.addEventListener('click', function () {
                        ratingButtons.forEach(btn => btn.classList.remove('on'));
                        this.classList.add('on');
                        ratingInput.value = this.getAttribute('data-value');
                        console.log('Rating set to:', this.getAttribute('data-value'));
                    });
                });
            }

        }, () => { }, () => { return true; });
    }

    toggleTag(event) {
        const tag = event.target;
        const tagName = tag.getAttribute('data-value');
        const isActive = tag.classList.contains('on');

        const endpoint = isActive ? `/api/artwork/remove-tag/${this.artworkId}` : `/api/artwork/add-tag/${this.artworkId}`;
        fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ tag: tagName })
        })
            .then(response => {
                if (response.ok) {
                    tag.classList.toggle('on');
                    //UIUtils.toast('success', `Tag ${isActive ? 'removed' : 'added'}.`);
                } else {
                    throw new Error('Failed to toggle tag');
                }
            })
            .catch(error => {
                UIUtils.toast('error', 'Error toggling tag.');
                console.error('Error:', error);
            });
    }
}